module.exports = "pegasus/assets/column-7-basic.png";